"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../../utils/utils");
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var StyledCheckbox = styled_components_1.default(antd_1.Checkbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n  &.ant-checkbox-wrapper {\n    align-items: flex-end;\n    & > *:last-child {\n      font-size: 12px;\n      font-weight: 500;\n      line-height: 100%;\n      padding-left: 15px;\n      color: #3b3b3b;\n    }\n  }\n"], ["\n  .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n  &.ant-checkbox-wrapper {\n    align-items: flex-end;\n    & > *:last-child {\n      font-size: 12px;\n      font-weight: 500;\n      line-height: 100%;\n      padding-left: 15px;\n      color: #3b3b3b;\n    }\n  }\n"])));
var CheckboxWrapper = styled_components_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  font-weight: bold;\n  @media only screen and (max-width: 819px) {\n    margin-bottom: 10px;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  font-weight: bold;\n  @media only screen and (max-width: 819px) {\n    margin-bottom: 10px;\n  }\n"])));
var CheckboxList = styled_components_1.default.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: start;\n  column-gap: 1.2em;\n  padding: 0;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: start;\n  column-gap: 1.2em;\n  padding: 0;\n"])));
var CheckboxListField = function (_a) {
    var name = _a.name, label = _a.label, dataList = _a.dataList, loading = _a.loading, error = _a.error, defaultChecked = _a.defaultChecked;
    var _b = formik_1.useField(name), field = _b[0], helpers = _b[2];
    var value = field.value || [];
    var handleClick = function (item) {
        if (value.find(function (itm) { return itm === item; })) {
            return helpers.setValue(value.filter(function (itm) { return itm !== item; }));
        }
        helpers.setValue(__spreadArrays(value, [item]));
    };
    react_1.useEffect(function () {
        if (defaultChecked)
            helpers.setValue((defaultChecked === null || defaultChecked === void 0 ? void 0 : defaultChecked.values) || []);
    }, [defaultChecked === null || defaultChecked === void 0 ? void 0 : defaultChecked.values]);
    return (react_1.default.createElement("fieldset", { name: name, style: { marginBottom: '1em', marginTop: '1em' } },
        react_1.default.createElement(Field_1.default, { loading: loading, error: error },
            react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
            react_1.default.createElement(CheckboxList, null, dataList.map(function (item) { return (react_1.default.createElement(CheckboxWrapper, { key: item.value },
                react_1.default.createElement(StyledCheckbox, { type: "checkbox", onClick: function () { return handleClick(item.value); }, onChange: function () { return handleClick(item.value); }, checked: field.value.includes(item.value), id: utils_1.NormalizeString(item.label) }, item.label.toUpperCase()))); })))));
};
CheckboxListField.defaultProps = {
    loading: false,
    error: undefined,
    defaultChecked: undefined,
};
exports.default = CheckboxListField;
var templateObject_1, templateObject_2, templateObject_3;
